module.exports = __webpack_public_path__ + "static/media/lol7.6ca16410.PNG";